import svgUrl from "ni:svgr;YUFm8KHZZfKWv6w-pdN6HWLpg2BHPpHks1emgsl9gaE";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const ExtractLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--clean--secondary)" d="M17 3a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6Z" /><path fill="var(--tbl--colors--icons--clean--primary)" fillRule="evenodd" d="M21.793 9.793a1 1 0 0 0 0 1.414l2.293 2.293H18.5a4 4 0 0 0-4 4v1a1 1 0 1 0 2 0v-1a2 2 0 0 1 2-2h5.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 0 0-1.414 0Z" clipRule="evenodd" /></svg>;
const Memo = memo(ExtractLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ExtractLIcon";
}